export default {
  en: {
    name: 'English',
    shortCode: 'en',
  },
  de: {
    name: 'Deutsch',
    shortCode: 'de',
  },
  he: {
    name: 'עברית',
    shortCode: 'he',
  },
};
